
import { Component, Vue } from "vue-property-decorator";
import { dataVisualizationModule } from "@/store";

@Component
export default class VisitYearDurationDescriptiveStatistics extends Vue {
  headerTranslations: Record<string, string> = {
    PatientCount: "Patientenanzahl",
    MeanVisitDuration : "Mittlere Besuchsdauer",
    StandardDeviation: "Standardabweichung",
    FirstQuartile: "Erstes Quartil",
    Median: "Median",
    ThirdQuartile : "Drittes Quartil"
  };
  // Use new getter with key-based data
  get chartData(): any[] {
    return dataVisualizationModule.getChartData("visitYearDurationDescriptiveStatistics");
  }

  get tableHeaders(): string[] {
    return this.chartData.length ? Object.keys(this.chartData[0]) : [];
  }

  async mounted() {
    try {
      await dataVisualizationModule.loadAll("visitYearDurationDescriptiveStatistics");
    } catch (e) {
      console.error("Failed to load chart data:", e);
    }
  }
}
